import dom from '../../../wrapper/DomWrapper';

import defaultImage from '../utils';
import errorHandler from './errorHandler';

const sectionBgErrorHandler = () => {
  const selectorName = '.section_bg ._error-wrap';
  const onError = (elImage, elParent) => {
    // eslint-disable-next-line no-param-reassign
    elImage.src = defaultImage;
    dom.addClass(elParent, 'picture-wrap_unavailable');
  };

  errorHandler(selectorName, onError);
};

export default sectionBgErrorHandler;
